var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var deepCamelize = function (data) {
    if (Array.isArray(data)) {
        return data.map(function (item) { return deepCamelize(item); });
    }
    if (typeof data === 'object' && data !== null) {
        return Object.keys(data).reduce(function (acc, key) {
            var _a;
            var newKey = key.replace(/_([a-z])/g, function (g) { return g[1].toUpperCase(); });
            return __assign(__assign({}, acc), (_a = {}, _a[newKey] = deepCamelize(data[key]), _a));
        }, {});
    }
    return data;
};
export var handleSnakeCaseString = function (status) {
    return status.replace('_', ' ');
};
